import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.ALERTS,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/AlertsContainer'),
      import('./reducers')
    ])
    injectReducer(store, { key: 'alerts', reducer: reducer.default })

    cb(null, module.default)
  }
})
